import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  &:hover {
    cursor: ${({showPointer}) => showPointer ? 'pointer' : 'default'};
  }
`;

export const Value = styled.span`
  ${({ color, bgColor }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    padding: 0;
    border-radius: 50%;
    min-width: 35px;
    min-height: 35px;
    color: ${color};
    background-color: ${bgColor};
    font-size: min(.8vw, .8em);
  `};
`;

export const Label = styled.span`
  font-weight: bold;
  font-size: 0.8em;
  color: #000;
  width: 100%;
  text-align: center;
  white-space: nowrap;
`;
